import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { GlobalService } from '@commoncore/services/global.service';
import { EnhancedShareFileOperationsModule } from '../../modules/helper-modules/enhanced-share-file-operations.module';

@Component({
  standalone:true,
  selector: 'app-enhanced-share-file-operations-wrapper',
  templateUrl: './enhanced-share-file-operations-wrapper.component.html',
  imports:[EnhancedShareFileOperationsModule,RouterModule]
})
export class EnhancedShareFileOperationsWrapperComponent {

  controller: any;
  fileOpsImplementationRef: any;
  fileOperationsHelperService: any;
  universalService: any;
  router: any;

  constructor(public globalService:GlobalService){
    this.fileOperationsHelperService = globalService.getFileOperationsHelperServiceRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
  }
  ngOnInit(): void {
    this.controller = FileOperationsController.getInstance(this.globalService);
    this.fileOpsImplementationRef  = this.controller.fileOperationsImplementation
  }
}
